export enum CreditStudyResultName {
  APPROVED = 'APPROVED',
  REJECTED_BY_SCORE = 'REJECTED_BY_SCORE',
  REJECTED_BY_DELINQUENCY = 'REJECTED_BY_DELINQUENCY',
}
